<!-- <app-citizen-home-header></app-citizen-home-header> -->

<app-header></app-header>

<!-- ===================================================== -->
<!-- SECTION: HERO / SEARCH - accueil, recherche de parcelle -->
<!-- ===================================================== -->
<main style="background: #ffffff">
  <div class="style_bg_img" style="background-image: url(&quot;assets/img/bg_img.png&quot;)">
    <div
      class="style_bg_img_bloc d-flex flex-column justify-content-center"
      style="min-height: 100vh"
    >
      <div class="container">
        <div class="py-5">
          <div class="row align-items-center justify-content-center text-center">
            <div class="col-lg-7 mx-auto">
              <div
                class=""
                data-aos="fade-down"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="1000"
              >
                <h1 class="display-5 style_bold">
                  {{ "WELCOME_1" | translate }}
                  <span class="text-primary">{{ "WELCOME_2" | translate }} </span
                  >{{ "WELCOME_3" | translate }}
                </h1>
              </div>
              <div class="col-sm-9 mx-auto my-3">
                <div
                  class="mb-2"
                  data-aos="fade-up"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="2000"
                >
                  <p>{{ "BIG_PARAGRAPHE_1" | translate }}</p>
                </div>
                <form
                  (ngSubmit)="displayParcellInformation()"
                  class="p-3 rounded-4 d-flex flex-column"
                  style="
                    background: linear-gradient(
                      282.39deg,
                      rgba(216, 211, 211, 0.4) 1.25%,
                      rgba(255, 255, 255, 0.1) 100%
                    );
                    border: solid 1px rgba(255, 255, 255, 0.2);
                    backdrop-filter: blur(3px);
                  "
                  data-aos="fade-up"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="1000"
                  data-aos-delay="200"
                >
                  <div class="form-floating style_form_feedback mb-3">
                    <input
                      type="text"
                      appNupIntegerLength
                      class="form-control"
                      id="floatingInput"
                      [(ngModel)]="numero"
                      name="numero"
                      placeholder="Numero unique parcelaire (ex: 1XXXXXXXX)"
                    />
                    <label for="floatingInput"> {{ "SEARCH_LIBELLE" | translate }}</label>
                    <div class="style_form_feedback_icon d-flex align-items-center">
                      <i class="bi-tag me-1" style="font-size: 1.5rem"></i>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-4">
                    <a
                      style="cursor: pointer"
                      href="https://test-cadastre.andf.bj/accueil"
                      target="_blank"
                      class="nav-link me-3 text-dark style_link"
                    >
                      <i class="bi-globe2 me-2"></i>{{ "GO_TO_MAP" | translate }}
                    </a>
                    <button class="btn btn-primary text-nowrap" type="submit" [disabled]="!numero">
                      <div
                        *ngIf="searc_loader"
                        class="spinner-border spinner-border-sm text-light"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <i *ngIf="!searc_loader" class="bi-search me-2"></i>
                      {{ "SEARCH_PARCEL" | translate }}
                    </button>
                  </div>
                  <div>
                    <!-- <a  (click)="accederAuxDemandes()" class="btn w-100 btn-dark py-3" type="submit">
                                            <i class="bi bi-save me-2"></i>
                                            {{ 'REGISTER_OWNPARCEL' | translate }}
                                        </a> -->
                    <a
                      data-bs-toggle="modal"
                      data-bs-target="#exampleforeHomeServiceModalWindow"
                      class="btn w-100 btn-dark py-3"
                      type="submit"
                    >
                      <i class="bi bi-save me-2"></i>
                      {{ "REGISTER_OWNPARCEL" | translate }}
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================================================== -->
  <!-- SECTION: MAP / FEATURED - image and feature highlights -->
  <!-- ===================================================== -->
  <div
    class="py-5 style_bg_img"
    style="background-image: url(&quot;assets/img/carte_bar_dark.png&quot;)"
  >
    <div class="container py-5">
      <div class="row align-items-center">
        <div
          class="col-sm-6 mb-4"
          data-aos="fade-right"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="mb-3">
            <h2 class="display-5">
              {{ "BIG_PARGRAPHE_2A" | translate }}
              <span class="text-success">{{ "BIG_PARGRAPHE_2B" | translate }}</span>
              {{ "BIG_PARGRAPHE_2C" | translate }}
            </h2>
            <p>{{ "BIG_PARGRAPHE_2D" | translate }}</p>
          </div>
          <div class="mb-4 d-flex flex-wrap">
            <div class="text-primary rounded-3 h-100 me-5 mb-3">
              <div class="d-flex">
                <h1 class="mb-0 me-3" style="line-height: 0px">
                  <i class="bi bi-map"></i>
                </h1>
                <div>
                  <h4 class="mb-0 style_bold" style="line-height: 20px">500 000</h4>
                  <small class="style_medium style_font_size_small">{{
                    "REGISTER_PARCELS" | translate
                  }}</small>
                </div>
              </div>
            </div>
            <div class="text-primary rounded-3 h-100 me-5 mb-3">
              <div class="d-flex">
                <h1 class="mb-0 me-3" style="line-height: 0px">
                  <i class="bi bi-arrow-left-right"></i>
                </h1>
                <div>
                  <h4 class="mb-0 style_bold" style="line-height: 20px">437</h4>
                  <small class="style_medium style_font_size_small">{{
                    "REGISTER_OPERATIONS" | translate
                  }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-sm-6"
          data-aos="fade-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div>
            <img src="assets/img/doc_img.png" class="img-fluid w-100" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================================================== -->
  <!-- SECTION: GEOMETERS / RESULTS - table with search & pagination -->
  <!-- ===================================================== -->
  <div class="container mb-5 pb-5">
    <div
      class="p-3 p-lg-5 rounded-5 style_gradient shadow-lg position-relative"
      style="border: #000000 10px solid; min-height: 780px"
    >
      <div class="d-flex flex-wrap gap-3 justify-content-between">
        <div class="">
          <h4 class="mb-0">{{ "GEO_TITLE" | translate }}</h4>
          <small class="text-muted"
            >{{ paginationData?.totalElements }} résultat(s) trouvé(s)</small
          >
        </div>

        <div class="d-flex gap-2 flex-wrap">
          <form class="d-flex flex-fill mb-2" role="search" (submit)="$event.preventDefault()">
            <div class="input-group">
              <input
                class="form-control"
                type="search"
                placeholder="Rechercher par nom..."
                aria-label="Search"
                aria-describedby="button-addon1"
                [value]="searchTerm"
                (input)="onSearchInput($any($event.target).value)"
              />
              <button
                class="btn btn-success border border-start-0 rounded-start-0"
                type="button"
                *ngIf="searchTerm"
                (click)="clearSearch()"
                title="Effacer la recherche"
              >
                <i class="bi-x"></i>
              </button>
              <button
                class="btn btn-success border border-start-0 rounded-start-0"
                type="button"
                *ngIf="!searchTerm"
              >
                <i class="bi-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div
        *ngIf="geometres.length === 0 && searchTerm"
        class="position-absolute top-50 start-50 translate-middle text-center w-100"
      >
        <div class="col-sm-8 col-lg-5 mx-auto my-5 text-center text-muted">
          <div class="mb-y">
            <h1 class="display-1"><i class="bi-search fs-1 text-muted"></i></h1>
            <h3 class="mb-3">Aucun géomètre trouvé pour "{{ searchTerm }}"</h3>
            <div class="text-center">
              <a (click)="clearSearch()" class="btn btn-success text-nowrap shadow-lg" type="button"
                >Effacer la recherche</a
              >
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="geometres.length === 0 && !searchTerm"
        class="position-absolute top-50 start-50 translate-middle text-center w-100"
      >
        <div class="col-sm-8 col-lg-5 mx-auto my-5 text-center text-muted">
          <div class="mb-y">
            <h1 class="display-1"><i class="bi-person-x fs-1 text-muted"></i></h1>
            <h3 class="mb-3">Aucun géomètre enregistré</h3>
          </div>
        </div>
      </div>

      <div class="table-responsive style_display_scrollbar" *ngIf="geometres.length > 0">
        <table class="table table-hover align-middle">
          <thead class="">
            <tr class="text-nowrap bg-white">
              <th scope="col">{{ "GEO_NAME" | translate }}</th>
              <th scope="col">{{ "Mail" | translate }}</th>
              <th scope="col">{{ "GEO_ADDRESS" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-nowrap bg-white" *ngFor="let geo of geometres; trackBy: trackByGeoId">
              <td>
                <div class="d-flex gap-2">
                  <div title="{{ geo.fullName }}">
                    <div
                      class="style_medium d-flex justify-content-center align-items-center text-white rounded-circle"
                      [style.background-color]="geo.fullName + geo.lastName | randomColor"
                      style="width: 40px; height: 40px; border: 3px solid #fff; font-size: 0.8em"
                    >
                      <span class="mb-0">{{ geo.fullName + " " + geo.lastName | initials }}</span>
                    </div>
                  </div>
                  <div>
                    <p class="mb-0 text-wrap style_semiBold">
                      {{ geo.fullName }} {{ geo.lastName }}
                    </p>
                    <small class="style_font_size_small text-muted">
                      {{ geo.profil }}
                    </small>
                  </div>
                </div>
              </td>
              <td>
                <p class="mb-0 text-wrap style_semiBold">
                  {{ geo.mail || "Cabinet non spécifié" }}
                </p>
                <small class="style_font_size_small text-muted">E-mail</small>
              </td>
              <td>
                <p class="mb-0 text-wrap style_semiBold">{{ geo.phone }}</p>
                <small class="style_font_size_small text-muted">{{
                  "GEO_ADDRESS" | translate
                }}</small>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <app-pagination
        *ngIf="geometres.length > 0"
        [paginationData]="paginationData"
        [hasPerPageSelector]="false"
        (onPageConfigsChange)="reloadGeometres($event)"
      ></app-pagination>
    </div>
  </div>

  <!-- ===================================================== -->
  <!-- SECTION: LATEST PUBLICATIONS - last public notices & list -->
  <!-- ===================================================== -->
  <div
    class="my-5 py-5"
    id="last-publication"
    *ngIf="lastestPublicationsData && lastestPublicationsData.content.length > 0"
  >
    <div
      class="d-flex flex-column justify-content-center py-5 bg-dark text-white style_bg_img"
      style="background-image: url(&quot;assets/img/carte_bpubliar_white.png&quot;)"
    >
      <div class="container py-5">
        <div class="col-lg-10 mx-auto">
          <div class="d-flex flex-column gap-5 w-100">
            <div class="col-lg-8 mx-auto text-center">
              <p style="font-size: 20px" class="text-success mb-0">
                {{ "PUB_SECTION_TITLE" | translate }}
              </p>
              <h1 class="display-5">{{ "PUB_SECTION_SUBTITLE" | translate }}</h1>
            </div>
            <div class="d-flex flex-column gap-2 w-100">
              <ng-template #loader>
                <div class="text-center my-5">
                  <div
                    class="spinner-border text-primary"
                    style="width: 3rem; height: 3rem"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </ng-template>
              <ng-container #data *ngIf="!publicationState.loading; else loader">
                <app-state-section
                  *ngIf="publicationState.error; else publicationList"
                  [state]="'error'"
                  [message]="publicationState.error"
                ></app-state-section>
                <ng-template #publicationList>
                  <div
                    *ngIf="lastestPublicationsData && lastestPublicationsData.content.length > 0"
                    class="d-flex flex-column gap-4"
                  >
                    <div
                      *ngFor="let publication of lastestPublicationsData.content"
                      class="border-bottom border-white border-opacity-25 w-100 text-center text-sm-start d-flex p-4"
                    >
                      <div
                        class="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-sm-start align-items-center w-100"
                      >
                        <div
                          style="width: 90px; height: 90px"
                          class="d-flex flex-column text-center rounded-3 justify-content-center align-items-center bg-success text-white"
                        >
                          <ng-container
                            *ngIf="
                              (publication.dateFin ?? (publication.dateDebut | addDays: 15)
                                | remainingDays) > 0;
                              else expired
                            "
                          >
                            <p class="mb-0 style_font_size_small">RESTE :</p>
                            <h3 class="mb-0 style_bold" style="line-height: 100%">
                              {{
                                publication.dateFin ?? (publication.dateDebut | addDays: 15)
                                  | remainingDays
                              }}
                            </h3>
                            <p class="mb-0 style_font_size_small">Jour(s)</p>
                          </ng-container>
                          <ng-template #expired>
                            <h1 class="mb-0 display-1" style="line-height: 100%">
                              <i class="bi-check"></i>
                            </h1>
                          </ng-template>
                        </div>
                        <div
                          class="d-flex flex-column flex-sm-row justify-content-sm-between gap-3 justify-content-center align-items-center align-items-sm-start flex-fill"
                        >
                          <div
                            class="d-flex gap-1 flex-column align-items-center align-items-sm-start"
                          >
                            <p class="mb-0 text-white text-opacity-50">
                              <i class="bi-geo-alt text-danger me-1"></i>
                              {{ publication.quartierParcelle }},&nbsp;
                              {{ publication.arrondissementParcelle }},&nbsp;
                              {{ publication.communeParcelle }}
                            </p>
                            <h4 class="mb-0 style_normal">NUP : {{ publication.nup }}</h4>
                            <p class="mb-0">{{ publication.proprietaire }}</p>
                          </div>
                          <div
                            class="d-flex gap-1 flex-column align-items-center align-items-sm-start"
                            style="min-width: 160px;"
                          >
                            <p class="mb-0 text-white text-opacity-50">
                              <i class="bi-fullscreen text-danger me-1"></i
                              >{{ "PUB_SUPERFICIE" | translate }}
                            </p>
                            <h4 class="mb-0 style_normal">
                              {{ publication?.superficie ?? 0 | number:'1.2-2' }} <small>m²</small>
                            </h4>
                            <button
                              class="btn btn-danger"
                              [disabled]="((publication.dateFin ?? (publication.dateDebut | addDays: 15)) | remainingDays) <= 0"
                              [attr.aria-disabled]="((publication.dateFin ?? (publication.dateDebut | addDays: 15)) | remainingDays) <= 0"
                              [attr.title]="((publication.dateFin ?? (publication.dateDebut | addDays: 15)) | remainingDays) <= 0 ? 'Publication clôturée' : ('PUB_OPPOSE_BTN' | translate)"
                            >
                              {{ "PUB_OPPOSE_BTN" | translate }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
            </div>
            <div class="text-center">
              <a routerLink="/publications" class="nav-link me-3 text-white style_link"
                ><i class="bi-arrow-right me-2"></i>{{ "PUB_VIEW_ALL" | translate }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================================================== -->
  <!-- SECTION: SERVICES - features and benefits -->
  <!-- ===================================================== -->
  <div class="container text-white mb-5">
    <div class="p-5 rounded-5 bg-success">
      <div class="row p-lg-5">
        <div
          class="col-sm-6"
          data-aos="fade-right"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="mb-4">
            <h1 class="mb-3 display-6">{{ "SERVICES_H1" | translate }}</h1>
            <p class="text-white text-opacity-75">
              {{ "SERVICES_P" | translate }}
            </p>
          </div>
          <div class="text-warning text-opacity-75">
            <div class="d-flex mb-3">
              <h1 class="me-3"><i class="bi-check-circle-fill"></i></h1>
              <h6>{{ "SERVICES_P1" | translate }}</h6>
            </div>
            <div class="d-flex mb-3">
              <h1 class="me-3"><i class="bi-check-circle-fill"></i></h1>
              <h6>{{ "SERVICES_P2" | translate }}</h6>
            </div>
            <div class="d-flex mb-3">
              <h1 class="me-3"><i class="bi-check-circle-fill"></i></h1>
              <h6>{{ "SERVICES_P3" | translate }}</h6>
            </div>
            <div class="d-flex mb-3">
              <h1 class="me-3"><i class="bi-check-circle-fill"></i></h1>
              <h6>{{ "SERVICES_P4" | translate }}</h6>
            </div>
          </div>
        </div>
        <div
          class="col-sm-6"
          data-aos="fade-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="row h-100">
            <div class="col pt-5">
              <div
                class="style_bg_img p-5 rounded-4 h-100"
                style="
                  background-image: url(&quot;assets/img/citoyen1.jpg&quot;);
                  min-height: 350px;
                "
              ></div>
            </div>
            <div class="col pb-5">
              <div
                class="style_bg_img p-5 rounded-4 h-100"
                style="
                  background-image: url(&quot;assets/img/citoyen2.jpg&quot;);
                  min-height: 350px;
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================================================== -->
  <!-- SECTION: USSD - short code promo/info -->
  <!-- ===================================================== -->
  <div
    class="py-5 container col-lg-8 mx-auto"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
    data-aos-duration="1000"
    data-aos-delay="200"
  >
    <div class="row align-items-center justify-content-between">
      <div class="col-sm mb-4">
        <h1 class="display-6">
          {{ "USSD_T1" | translate }}
          <span class="text-primary">{{ "USSD_T2" | translate }}</span>
          {{ "USSD_T3" | translate }}
        </h1>
      </div>
      <div class="col-sm-auto mb-4">
        <h1 class="display-1 style_bolder text-primary">*401#</h1>
      </div>
    </div>
  </div>

  <div class="container text-white mb-5">
    <div class="p-5 rounded-5 bg-primary">
      <div class="row p-lg-5">
        <div
          class="col-sm-6"
          data-aos="fade-right"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="row h-100">
            <div class="col pt-5">
              <div
                class="style_bg_img p-5 rounded-4 h-100"
                style="background-image: url(&quot;assets/img/pro1.jpg&quot;); min-height: 350px"
              ></div>
            </div>
            <div class="col pb-5">
              <!-- ===================================================== -->
              <!-- SECTION: SOLUTIONS / PRO - marketing blocks -->
              <!-- ===================================================== -->
              <div
                class="style_bg_img p-5 rounded-4 h-100"
                style="background-image: url(&quot;assets/img/pro2.jpg&quot;); min-height: 350px"
              ></div>
            </div>
          </div>
        </div>
        <div
          class="col-sm-6"
          data-aos="fade-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="mb-4">
            <h2 class="mb-3 display-6">{{ "SOLUTION_H1" | translate }}</h2>
          </div>
          <div class="text-warning text-opacity-75">
            <div class="d-flex mb-3">
              <h1 class="me-3"><i class="bi-check-circle-fill"></i></h1>
              <h6>{{ "SOLUTION_P1" | translate }}</h6>
            </div>
            <div class="d-flex mb-3">
              <h1 class="me-3"><i class="bi-check-circle-fill"></i></h1>
              <h6>{{ "SOLUTION_P2" | translate }}</h6>
            </div>
            <div class="d-flex mb-3">
              <h1 class="me-3"><i class="bi-check-circle-fill"></i></h1>
              <h6>{{ "SOLUTION_P3" | translate }}</h6>
            </div>
            <div class="d-flex mb-3">
              <h1 class="me-3"><i class="bi-check-circle-fill"></i></h1>
              <h6>{{ "SOLUTION_P4" | translate }}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================================================== -->
  <!-- SECTION: PARTNERS / CAROUSEL -->
  <!-- ===================================================== -->
  <div class="bg-white py-3">
    <div class="container">
      <div class="my-auto style_slick-track" id="slide_patenaire">
        <div class="p-5">
          <a href="#">
            <img src="assets/img/patenaires/apiex.png" class="d-block rounded-lg w-100" alt="..." />
          </a>
        </div>
        <div class="p-5">
          <a href="#">
            <img src="assets/img/patenaires/RPB.png" class="d-block rounded-lg w-100" alt="..." />
          </a>
        </div>
        <div class="p-5">
          <a href="#">
            <img
              src="assets/img/patenaires/cdre_vie.png"
              class="d-block rounded-lg w-100"
              alt="..."
            />
          </a>
        </div>
        <div class="p-5">
          <a href="#">
            <img src="assets/img/patenaires/andf.png" class="d-block rounded-lg w-100" alt="..." />
          </a>
        </div>
        <div class="p-5">
          <a href="#">
            <img src="assets/img/patenaires/anip.png" class="d-block rounded-lg w-100" alt="..." />
          </a>
        </div>
        <div class="p-5">
          <a href="#">
            <img src="assets/img/patenaires/dgi.png" class="d-block rounded-lg w-100" alt="..." />
          </a>
        </div>
        <div class="p-5">
          <a href="#">
            <img src="assets/img/patenaires/mef.png" class="d-block rounded-lg w-100" alt="..." />
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================================================== -->
  <!-- SECTION: FAQ - frequently asked questions accordion -->
  <!-- ===================================================== -->
  <div class="py-5 bg-primary bg-opacity-10">
    <div class="container">
      <div class="col-lg-6 col-sm-8 mx-auto py-5">
        <div
          class="mb-5 text-center"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <h1 class="display-5 style_bold">
            {{ "FAQ_TITLE" | translate }}
          </h1>
        </div>

        <div class="accordion accordion-flush" id="accordionFlushExample">
          <div
            class="accordion-item rounded-4 text-muted bg-white border-0 mb-2"
            data-aos="fade-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div class="accordion-header">
              <div
                class="accordion-button collapsed bg-transparent"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                <h6 class="mb-0">{{ "FAQ_Q1" | translate }}</h6>
              </div>
            </div>

            <div
              id="flush-collapseOne"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <p class="text-dark mb-0">
                  {{ "FAQ_A1" | translate }}
                </p>
              </div>
            </div>
          </div>

          <div
            class="accordion-item rounded-4 text-muted bg-white border-0 mb-2"
            data-aos="fade-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div class="accordion-header">
              <div
                class="accordion-button collapsed bg-transparent"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapse2"
                aria-expanded="false"
                aria-controls="flush-collapse2"
              >
                <h6 class="mb-0">{{ "FAQ_Q2" | translate }}</h6>
              </div>
            </div>

            <div
              id="flush-collapse2"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <p class="text-dark mb-0">
                  {{ "FAQ_A2" | translate }}
                </p>
                <ol>
                  <li>{{ "FAQ_A2_STEP1" | translate }}</li>
                  <li>{{ "FAQ_A2_STEP2" | translate }}</li>
                  <li>{{ "FAQ_A2_STEP3" | translate }}</li>
                  <li>{{ "FAQ_A2_STEP4" | translate }}</li>
                  <li>{{ "FAQ_A2_STEP5" | translate }}</li>
                </ol>
              </div>
            </div>
          </div>

          <div
            class="accordion-item rounded-4 text-muted bg-white border-0 mb-2"
            data-aos="fade-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div class="accordion-header">
              <div
                class="accordion-button collapsed bg-transparent"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapse3"
                aria-expanded="false"
                aria-controls="flush-collapse3"
              >
                <h6 class="mb-0">
                  {{ "FAQ_Q3" | translate }}
                </h6>
              </div>
            </div>

            <div
              id="flush-collapse3"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <p class="text-dark mb-0">
                  {{ "FAQ_A3" | translate }}
                </p>
              </div>
            </div>
          </div>

          <div
            class="accordion-item rounded-4 text-muted bg-white border-0 mb-2"
            data-aos="fade-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div class="accordion-header">
              <div
                class="accordion-button collapsed bg-transparent"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapse4"
                aria-expanded="false"
                aria-controls="flush-collapse4"
              >
                <h6 class="mb-0">
                  {{ "FAQ_Q4" | translate }}
                </h6>
              </div>
            </div>

            <div
              id="flush-collapse4"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <p class="text-dark mb-0">
                  {{ "FAQ_A4" | translate }}
                </p>
                <ul>
                  <li>{{ "FAQ_A4_DOC1" | translate }}</li>
                  <li>{{ "FAQ_A4_DOC2" | translate }}</li>
                  <li>{{ "FAQ_A4_DOC3" | translate }}</li>
                  <li>{{ "FAQ_A4_DOC4" | translate }}</li>
                  <li>{{ "FAQ_A4_DOC5" | translate }}</li>
                </ul>
              </div>
            </div>
          </div>

          <div
            class="accordion-item rounded-4 text-muted bg-white border-0 mb-2"
            data-aos="fade-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div class="accordion-header">
              <div
                class="accordion-button collapsed bg-transparent"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapse5"
                aria-expanded="false"
                aria-controls="flush-collapse5"
              >
                <h6 class="mb-0">{{ "FAQ_Q5" | translate }}</h6>
              </div>
            </div>

            <div
              id="flush-collapse5"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <p class="text-dark mb-0">{{ "FAQ_A5" | translate }}</p>
                <ul>
                  <li>{{ "FAQ_A5_OPTION1" | translate }}</li>
                  <li>{{ "FAQ_A5_OPTION2" | translate }}</li>
                  <li>{{ "FAQ_A5_OPTION3" | translate }}</li>
                </ul>
              </div>
            </div>
          </div>

          <div
            class="accordion-item rounded-4 text-muted bg-white border-0 mb-2"
            data-aos="fade-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div class="accordion-header">
              <div
                class="accordion-button collapsed bg-transparent"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapse6"
                aria-expanded="false"
                aria-controls="flush-collapse6"
              >
                <h6 class="mb-0">
                  {{ "FAQ_Q6" | translate }}
                </h6>
              </div>
            </div>

            <div
              id="flush-collapse6"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <p class="text-dark mb-0">
                  {{ "FAQ_A6" | translate }}
                </p>
              </div>
            </div>
          </div>

          <div
            class="accordion-item rounded-4 text-muted bg-white border-0 mb-2"
            data-aos="fade-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div class="accordion-header">
              <div
                class="accordion-button collapsed bg-transparent"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapse7"
                aria-expanded="false"
                aria-controls="flush-collapse7"
              >
                <h6 class="mb-0">{{ "FAQ_Q7" | translate }}</h6>
              </div>
            </div>

            <div
              id="flush-collapse7"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <p class="text-dark mb-0">
                  {{ "FAQ_A7" | translate }}
                </p>
              </div>
            </div>
          </div>

          <div
            class="accordion-item rounded-4 text-muted bg-white border-0 mb-2"
            data-aos="fade-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div class="accordion-header">
              <div
                class="accordion-button collapsed bg-transparent"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapse8"
                aria-expanded="false"
                aria-controls="flush-collapse8"
              >
                <h6 class="mb-0">{{ "FAQ_Q8" | translate }}</h6>
              </div>
            </div>

            <div
              id="flush-collapse8"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <p class="text-dark mb-0">
                  {{ "FAQ_A8" | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================================================== -->
  <!-- SECTION: CALL-TO-ACTION - final CTA with images -->
  <!-- ===================================================== -->
  <div class="style_gradient">
    <div class="container-fluid">
      <div
        class="row style_bg_img"
        style="background-image: url(&quot;assets/img/carte_bar_dark.png&quot;)"
      >
        <div
          class="col-sm align-self-center"
          data-aos="fade-right"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="col ps-sm-5 ms-sm-5 mx-auto py-5">
            <div class="ms-sm-3">
              <h1 class="text-dark mb-4">{{ "BIG_TEXT_A" | translate }}</h1>
              <a
                data-bs-toggle="modal"
                data-bs-target="#exampleforeHomeServiceModalWindow"
                class="btn btn-primary text-nowrap shadow-lg"
                type="button"
                ><i class="bi-save-2 me-2"></i>{{ "BIG_TEXT_REGISTER_BTN" | translate }}</a
              >
            </div>
          </div>
        </div>
        <div
          class="col-sm p-0"
          data-aos="fade-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div
            class="h-100 style_bg_img p-5"
            style="background-image: url(&quot;assets/img/pro3.png&quot;); min-height: 500px"
          ></div>
        </div>
      </div>
    </div>
  </div>
</main>

<!-- Modal -->
<div
  class="modal fade"
  id="exampleforeHomeServiceModalWindow"
  data-bs-backdrop="static"
  tabindex="-1"
  aria-labelledby="exampleforeServiceModalWindowLabel"
  aria-hidden="true"
  style="
    background: linear-gradient(
      90deg,
      rgba(226, 244, 242, 0.6) -2.71%,
      rgba(248, 248, 239, 0.6) 58.43%,
      rgba(249, 237, 238, 0.6) 100%
    );
  "
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content border-0">
      <div class="modal-header border-0 align-items-start">
        <h5 class="mb-0" id="exampleforeServiceModalWindowLabel">Enregistrement individuel</h5>
        <button
          type="button"
          class="btn-close ms-md-5"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p>Procédure :</p>
        <p>
          1. Contacter un géomètre expert accrédité par l'ANDF (voir la liste des géomètres) et
          convenir du montant de la prestation
        </p>
        <p>
          2. constituer un dossier comprenant
          <span style="font-size: medium">
            une fiche de renseignement dûment remplie et signée par le requérant, CIP, photocopie du
            TF si disponible, preuve de droit, autres pièces se rattachant à la parcelle
          </span>
        </p>
        <p>3. Inviter le géomètre en cas d'accord à procéder à l’enregistrement de la parcelle,</p>
        <p>
          4. Le dossier est traité par l'ANDF et en cas d'approbation le CEC est envoyé par voie
          numérique au géomètre . En cas de rejet, le géomètre est invité à soumettre à nouveau les
          fichiers.
        </p>
        <p>
          5. Le géomètre transmet le CEC au requérant dès que ses frais de prestations sont payés .
        </p>
      </div>
      <div class="modal-footer border-0 d-flex justify-content-between align-items-end">
        <div>
          <h6 class="mb-0 style_bold">1 Fcfa</h6>
          <p class="mb-0 style_font_size_small">Coûts</p>
        </div>
        <div>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            <i class="bi-x me-1"></i>Fermer
          </button>
          <!-- <a (click)="goToselectedEservice(idEservice)" type="button" class="btn btn-success shadow-sm ms-2" ><i class="bi-arrow-right me-1"></i>Continuer</a> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal detail sur Une personne physique r-->
<div
  class="modal fade"
  id="exampleModalInitialisationDetails"
  data-bs-backdrop="static"
  tabindex="-1"
  aria-labelledby="exampleModalInfosNaturalPersonLabel"
  aria-hidden="true"
  style="background-color: rgba(197, 206, 224, 0.7)"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0">
      <div class="modal-header border-0 pb-0 align-items-start">
        <h5 class="mb-0" id="exampleModalInitialisationDetailsLabel">
          Informations sur la parcelle
        </h5>
        <button
          type="button"
          class="btn-close ms-md-5"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <form class="">
          <div class="mb-3">
            <div class="card border-success mb-3">
              <div
                class="py-4 card-header bg-success text-white style_bg_img d-flex justify-content-between align-items-center"
                style="background-image: url(&quot;assets/img/carte_bar.png&quot;)"
              >
                <div class="me-3">
                  <h2 class="mb-0 style_bold">
                    {{ parcelle?.nup || "NUP non renseigné" }}
                  </h2>
                  <p class="mb-0 style_font_size_small">Numéro unique parcelaire</p>
                </div>
                <a
                  href="https://test-cadastre.andf.bj/nup/{{ parcelle?.nup }}"
                  class="style_link text-end"
                  >Voir la carte</a
                >
              </div>

              <div class="card-body">
                <div class="mb-3">
                  <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                    <div class="row">
                      <div class="col-sm">
                        <span>Surface estimée en m²</span>
                      </div>
                      <div class="col-sm">
                        <strong>
                          {{ parcelle?.calculatedArea || "Non renseigné" }}
                          (m²)
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                    <div class="row">
                      <div class="col-sm">
                        <span>Type parcelle</span>
                      </div>
                      <div class="col-sm">
                        <strong>
                          {{ parcelle?.registerType || "Non renseigné" }}
                        </strong>
                      </div>
                    </div>
                  </div>

                  <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                    <div class="row">
                      <div class="col-sm">
                        <span>Département</span>
                      </div>
                      <div class="col-sm">
                        <strong>{{ parcelle?.departementName || "Non renseigné" }} </strong>
                      </div>
                    </div>
                  </div>

                  <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                    <div class="row">
                      <div class="col-sm">
                        <span>Commune</span>
                      </div>
                      <div class="col-sm">
                        <strong>
                          {{ parcelle?.communeName || "Non renseigné" }}
                        </strong>
                      </div>
                    </div>
                  </div>

                  <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                    <div class="row">
                      <div class="col-sm">
                        <span>Arrondissement</span>
                      </div>
                      <div class="col-sm">
                        <strong>
                          {{ parcelle?.arrondissementName || "Non renseigné" }}
                        </strong>
                      </div>
                    </div>
                  </div>

                  <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                    <div class="row">
                      <div class="col-sm">
                        <span>Quartier</span>
                      </div>
                      <div class="col-sm">
                        <strong>
                          {{ parcelle?.quartierName || "Non renseigné" }}
                        </strong>
                      </div>
                    </div>
                  </div>

                  <div class="rounded-3 p-2 mb-2 style_gradient style_font_size_small">
                    <div class="row">
                      <div class="col-sm">
                        <span>Référence locale</span>
                      </div>
                      <div class="col-sm">
                        <strong>
                          {{ parcelle?.localParcelIdentification || "Non renseigné" }}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <a class="nav-link text-dark text-center text-decoration-underline" style="cursor: pointer;" (click)="call_Moadl_droit_restric()" >Droits et restrictions</a> -->
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- <div class="modal-footer border-0 pt-0">
               <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><i class="bi-x me-1"></i>
                   Fermer
               </button>
           </div> -->
    </div>
  </div>
</div>

<!-- Notification -->
<app-toastr-alert #toastrAlert></app-toastr-alert>
